import { Button } from '@fluentui/react-components';

type TProps = {
  logout: (logoutUri?: string) => void;
};

// used by AuthContext.tsx
const Logout = ({ logout }: TProps) => {
  return (
    <div className="p-4">
      <p className="text-lg mb-2">Click on the button below to sign-out and sign-in again. This may fix your issue.</p>
      <Button appearance="primary" onClick={() => logout('/')}>
        Logout
      </Button>
    </div>
  );
};

export default Logout;
